// extracted by mini-css-extract-plugin
export default {"lakesBrand":"livestream_lake_blurb__lakesBrand--c0Qu","lakesList":"livestream_lake_blurb__lakesList--0Evh","presentedBy":"livestream_lake_blurb__presentedBy--Yai6"};